<template>
  <div class="tempControl">
    <div class="sketchMap"></div>
    <div class="paramsInfo-part">
      <CardContainer class="temperature-part">
        <div class="temperatureSetTitle">{{ $t('Product.temperatureControlPart') }}</div>
        <div class="temperature-list" v-for="(stateItem, i) in form.temperatureConfigs" :key="i">
          <span class="title">{{ $t('Product.params') }}{{ i + 1 }}:</span>
          <div class="content">
            <div class="content-item">
              <span class="title">{{ $t('Product.paramName') }}:</span>
              <div class="langPart">
                <div
                  v-for="(lang, i2) in stateItem.languages"
                  :key="lang.language"
                  class="langItem"
                >
                  <el-select v-model="lang.language" class="speInput2" size="small">
                    <el-option
                      v-for="item in languageList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="stateItem.languages.some((name) => name.language === item.value)"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    v-model="lang.name"
                    size="small"
                    class="speInput"
                    :placeholder="$t('Product.params')"
                  ></el-input>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('Common.delete')"
                    placement="top-start"
                    v-if="stateItem.languages && stateItem.languages.length !== 1"
                  >
                    <div class="iconDiv" @click="deleteLang(i, i2)">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-del_16"></use>
                      </svg>
                    </div>
                  </el-tooltip>
                </div>
                <div
                  class="add-bt"
                  @click="addLang(i)"
                  v-show="stateItem.languages.length !== languageList.length"
                >
                  <span>+{{ $t('Common.create') }}</span>
                </div>
              </div>
              <div class="btPart">
                <el-button
                  type="text"
                  :style="form.temperatureConfigs.length === 1 || i === 0 ? null : 'color:#A1A5AD'"
                  size="mini"
                  @click="temperatureConfigsUp(i)"
                  :disabled="form.temperatureConfigs.length === 1 || i === 0"
                >
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-move"></use>
                  </svg>
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  :style="
                    form.temperatureConfigs.length === 1 || i === form.temperatureConfigs.length - 1
                      ? null
                      : 'color:#A1A5AD'
                  "
                  @click="temperatureConfigsDown(i)"
                  :disabled="
                    form.temperatureConfigs.length === 1 || i === form.temperatureConfigs.length - 1
                  "
                >
                  <svg class="icon" aria-hidden="true" style="transform: rotate(180deg);">
                    <use xlink:href="#icon-move"></use>
                  </svg>
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="temperatureConfigsDelete(i)"
                  style="color:#A1A5AD"
                >
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-del_241"></use>
                  </svg>
                </el-button>
              </div>
            </div>
            <div class="content-item">
              <span class="title">{{ $t('Product.displayTemperature') }}:</span>
              <Select
                class="select-part"
                :options="stateListOptions"
                v-model="stateItem.showTemperature"
                :placeholder="$t('Product.params')"
                :labelOptions="{
                  key: 'identifier',
                  value: 'name'
                }"
              >
              </Select>
            </div>
            <div class="content-item">
              <span class="title">{{ $t('Product.setTemperature') }}:</span>
              <Select
                class="select-part"
                :options="stateListOptions"
                v-model="stateItem.setTemperature"
                :placeholder="$t('Product.params')"
                :labelOptions="{
                  key: 'identifier',
                  value: 'name'
                }"
              >
              </Select>
            </div>
            <div class="content-item">
              <span class="title">{{ $t('Product.setUpperTemperature') }}:</span>
              <Select
                class="select-part"
                :options="stateListOptions"
                v-model="stateItem.cabinetTemperatureMax"
                :placeholder="$t('Product.params')"
                :labelOptions="{
                  key: 'identifier',
                  value: 'name'
                }"
              >
              </Select>
            </div>
            <div class="content-item">
              <span class="title">{{ $t('Product.setLowerLimitTemperature') }}:</span>
              <Select
                class="select-part"
                :options="stateListOptions"
                v-model="stateItem.cabinetTemperatureMin"
                :placeholder="$t('Product.params')"
                :labelOptions="{
                  key: 'identifier',
                  value: 'name'
                }"
              >
              </Select>
            </div>
          </div>
        </div>

        <div
          class="addBt"
          @click="addStateConfigs"
          v-if="stateListOptions && form.temperatureConfigs && stateListOptions.length > 0"
        >
          {{ $t('Common.create') }}
        </div>
      </CardContainer>
    </div>
    <div class="bottomBt">
      <hl-button
        type="secondary"
        @click.native="save"
        :loading="saveLoading"
        :style="publishShow ? '' : 'margin-right:24px'"
      >
        {{ $t('Common.save') }}
      </hl-button>
      <hl-button
        @click.native="publish"
        v-show="publishShow"
        style="margin-right:24px"
        :loading="publishLoading"
      >
        {{ $t('Common.publish') }}
      </hl-button>
    </div>
  </div>
</template>

<script>
import Select from '@/components/CommonForm/Select'
import { languageList } from '@/config/status.js'
import i18n from '../../../../../locales'
export default {
  name: 'index',
  props: {
    productKey: {
      type: String,
      default: ''
    }
  },
  components: {
    Select
  },
  data() {
    return {
      languageList,
      form: {
        temperatureConfigs: [
          {
            showTemperature: '',
            setTemperature: '',
            cabinetTemperatureMax: '',
            cabinetTemperatureMin: '',
            languages: [
              {
                language: '',
                name: ''
              }
            ]
          }
        ]
      },
      stateListOptions: [],
      saveLoading: false,
      publishShow: true,
      publishLoading: false
    }
  },
  created() {
    this.getTempInfoList()
  },
  mounted() {
    this.initData()
  },
  methods: {
    //初始化赋值
    initData() {
      if (this.productKey) {
        const params = {
          productKey: this.productKey
        }
        this.$ajax
          .get(this.$api.product.iceProduct_temperature_control_detail, params)
          .then((res) => {
            if (res.data) {
              this.form = {
                temperatureConfigs: res.data.temperatureConfigs || [
                  {
                    showTemperature: '',
                    setTemperature: '',
                    cabinetTemperatureMax: '',
                    cabinetTemperatureMin: '',
                    languages: [
                      {
                        language: '',
                        name: ''
                      }
                    ]
                  }
                ]
              }
              this.publishShow = res.data.update
            } else {
              this.form = {
                temperatureConfigs: [
                  {
                    showTemperature: '',
                    setTemperature: '',
                    cabinetTemperatureMax: '',
                    cabinetTemperatureMin: '',
                    languages: [
                      {
                        language: '',
                        name: ''
                      }
                    ]
                  }
                ]
              }
            }
          })
      } else {
        this.form = {
          temperatureConfigs: []
        }
      }
    },
    // 添加语言
    addLang(i) {
      this.form.temperatureConfigs[i].languages.push({
        language: '',
        name: ''
      })
    },
    // 删除语言
    deleteLang(i, i2) {
      this.form.temperatureConfigs[i].languages.splice(i2, 1)
    },
    //获取状态列表下拉框
    getTempInfoList() {
      const params = {
        productKey: this.productKey,
        draft: false
      }
      this.$ajax.get(this.$api.product.product_tsl_property_list, params).then((res) => {
        this.stateListOptions = res.data
      })
    },
    checkForm(arr) {
      let pass = true
      pass = arr.every((x1) => {
        return (
          x1.showTemperature &&
          x1.setTemperature &&
          x1.cabinetTemperatureMax &&
          x1.cabinetTemperatureMin &&
          x1.languages.length > 0 &&
          this.checkLang(x1.languages)
        )
      })
      if (!pass) {
        this.$message.warning(`${i18n.t('Product.saveCheckTips')}`)
      }

      return pass
    },
    checkLang(arr) {
      let pass = true
      pass = arr.every((item) => {
        let keys = Object.keys(item)
        return keys.every((key) => {
          return item[key] && item[key].length > 0
        })
      })
      return pass
    },
    save() {
      if (!this.checkForm(this.form.temperatureConfigs)) return
      this.saveLoading = true
      let params = {
        productKey: this.productKey,
        temperatureConfigs: this.form.temperatureConfigs
      }
      let api = this.$api.product.iceProduct_temperature_control_save
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.saveSuccess')}`)
            this.publishShow = true
          }

          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.saveLoading = false
        })
    },
    publish() {
      this.publishLoading = true
      let params = {
        productKey: this.productKey
      }
      let api = this.$api.product.iceProduct_temperature_control_publish
      this.$ajax
        .get(api, params)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.operationSuccess')}`)
            this.publishShow = false
          }
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.publishLoading = false
        })
    },
    //获取状态列表下拉框
    getFuncStateList() {
      const params = {
        productKey: this.productKey
      }
      this.$ajax.get(this.$api.product.product_template_func_state_select, params).then((res) => {
        this.stateListOptions = res.data
      })
    },

    //状态上移
    temperatureConfigsUp(i) {
      let arr = JSON.parse(JSON.stringify(this.form.temperatureConfigs))
      arr.splice(i - 1, 1, ...arr.splice(i, 1, arr[i - 1]))
      this.form.temperatureConfigs = arr
    },
    //状态下移
    temperatureConfigsDown(i) {
      let arr = JSON.parse(JSON.stringify(this.form.temperatureConfigs))
      arr.splice(i, 1, ...arr.splice(i + 1, 1, arr[i]))
      this.form.temperatureConfigs = arr
    },
    //状态删除
    temperatureConfigsDelete(i) {
      this.form.temperatureConfigs.splice(i, 1)
    },
    //新增状态
    addStateConfigs() {
      this.form.temperatureConfigs.push({
        showTemperature: '',
        setTemperature: '',
        cabinetTemperatureMax: '',
        cabinetTemperatureMin: '',
        languages: [
          {
            language: '',
            name: ''
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tempControl {
  display: flex;
  .sketchMap {
    height: 720px;
    width: 330px;
    background-image: url('../../../../../assets/product_model_pic_temperature_control.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .paramsInfo-part {
    margin-left: 24px;
    flex: 1;
    .temperature-part {
      margin-bottom: 24px;
      .temperatureSetTitle {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
      }
      .temperature-list {
        display: flex;
        align-items: center;
        margin-top: 16px;
        .title {
          color: #303133;
        }
        .content {
          margin-left: 16px;
          min-width: 690px;
          //display: flex;
          padding: 16px;
          justify-content: space-between;
          align-items: center;
          line-height: 56px;
          //height: 64px;
          border: 1px dashed #e4e7ed;
          border-radius: 8px;
          flex: 1;
          .content-item {
            position: relative;
            display: flex;
            .title {
              text-align: right;
              min-width: 172px;
              margin-right: 8px;
            }
            .langPart {
              //width: 400px;
              width: calc(100% - 90px);
              min-width: 300px;
              max-width: 610px;
              padding: 16px;
              border: 1px solid rgba(220, 223, 230, 1);
              border-radius: 8px;
              margin-right: 90px;
              .langItem {
                display: flex;
                position: relative;
                //.speInput2{
                //  width: 200px;
                //  margin-right: 8px;
                //}
                //.speInput {
                //  width: 280px;
                //  margin-right: 8px;
                //}
                /deep/ .speInput {
                  //width: 400px !important;
                  min-width: 200px;
                  max-width: 400px;
                  .el-input.el-input--small.el-input--suffix {
                    //width: 400px !important;
                    min-width: 200px;
                    max-width: 400px;
                  }
                }
                /deep/ .speInput2 {
                  margin-right: 8px;
                  width: 140px !important;

                  .el-input.el-input--small.el-input--suffix {
                    width: 140px !important;
                  }
                }
                .iconDiv {
                  //position: absolute;
                  //right: 0px;
                  margin-left: 24px;
                }
              }
            }
            .btPart {
              position: absolute;
              right: 0px;
            }
          }
          .temperature-select {
            display: flex;
            .select-part {
              margin-right: 8px;
            }
            .input-part {
              width: 150px;
              margin-right: 8px;
            }
            .uploadTips {
              margin-left: -240px;
              font-size: 12px;
              color: #909399;
            }
          }
          .btPart {
            display: flex;
          }
        }
      }
    }
  }
}
.add-bt {
  margin-top: 8px;
  width: 100%;
  background: #ffffff;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  line-height: 32px;
  span {
    color: #2046c7;
  }
  &:hover {
    background: #eff4fc;
    border-radius: 4px;
    border: 2px dashed #dadfe6;
  }
  &:active {
    background: #e3e8f0;
    border-radius: 4px;
    border: 2px solid #dadfe6;
  }
}
.addBt {
  margin-top: 24px;
  height: 32px;
  background: #f0f2fc;
  border-radius: 4px;
  border: 1px solid #8fa2e3;
  text-align: center;
  line-height: 32px;
  color: #2046c7;
  cursor: pointer;
  &:hover {
    background: #f0f2fc;
    border: 1px solid #bcc7ee;
  }
  &:active {
    background: #bcc7ee;
    border: 1px solid #637dd7;
  }
}
.btPart {
}
.bottomBt {
  background-color: #ffffff;
  left: -24px;
  right: -24px;
  position: fixed;
  bottom: 0;
  z-index: 4;
  height: 50px;
  width: calc(100vw + 240px);
  border-radius: 16px;
  text-align: right;
  padding-right: 214px;
  padding-top: 10px;
  box-shadow: 5px 0 25px 8px rgba(215, 222, 230, 0.4);
}
</style>
